import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-05/lesson-12/task-01";

const task: Slide = {
  titleHtml:
    "Estimate the reverberaton time in small conference room (N = 7 seats)<br>with dimensions L (lenght) = 6 m, W (width) = 4.8 m and H (height) = 2.7 m without<br>any treatment (brick wall-average absorption coefficient α = 0.15).<br>Is this reverberation time appropriate for speech?",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/12/task/task-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
